import { LOGO_BASE64 } from "./logoBase64";

function SalesOrderPrintComponent(data, items, moment, qty) {
    return `<!DOCTYPE html>
            <html lang="en">

            <head>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <title>Quzone</title>
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/paper-css/0.3.0/paper.css">
                <style>
                    @media print {
                        body {
                            width: 104mm !important;
                            height: 3276mm !important;
                            margin: 0.2mm 0.2mm 0.2mm 0.2mm !important;
                            /* change the margins as you want them to be. */
                        }
                    }
                    @page {
                    width: 104mm !important;
                    height: 3276mm !important;
                    margin: 0.2mm 0.2mm 0.2mm 0.2mm !important;
                    /* change the margins as you want them to be. */
                }
                p{
                    margin: 0px !important;
                }
                </style>
            </head>

            <body style="font-family:  Calibri, sans-serif;">
                <div style="text-align: center;">
                    <img src="${LOGO_BASE64}" alt="QUZONE" style="max-height: 70px; max-width: 180px; object-fit: contain; margin-bottom: 5px;" />
                </div>
                <div style="font-size:20px;text-align:center;">
                    <p>Sale Order</p>
                </div>
                <hr style="height:2px; width:100%; border-width:0; color:black; background-color:black">
                <div style="display: flex;justify-content: space-evenly;">
                    <div>
                        <p>Order ID: </b>${data.order_id}</p>
                    </div>
                    <div>
                        <p>Data & Time :${moment(data.timestamp).format("DD-MM-YYYY HH:MM")}</p>
                    </div>
                </div>
                <div style="font-size: 20px; padding-left: 20px;">
                    <b>Name : ${data?.user?.first_name}</b> <br>
                    <b>Phone No : ${data?.user?.username}</b>
                </div>
                <hr style="height:2px; width:100%; border-width:0; color:black; background-color:black">
                <table style="width: 100%; border-collapse: collapse; font-family: Calibri, sans-serif; font-size: 13px;">
                  <thead>
                    <tr style="border-bottom: 2px solid black;">
                      <th style="text-align: left; width: 50%; padding: 4px 0 4px 10px;">Item / Details</th>
                      <th style="text-align: right; width: 15%; padding: 4px 0;">Qty</th>
                      <th style="text-align: right; width: 15%; padding: 4px 0;">Rack</th>
                      <th style="text-align: right; width: 20%; padding: 4px 10px 4px 0;">Variant</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${items}
                  </tbody>
                </table>
                <hr style="height:2px; width:100%; border-width:0; color:black; background-color:black">
                <div style="display: flex;justify-content: space-evenly;">
                    <div>Total</div>
                    <div>${data.cart.cartitem.length} Items</div>
                    <div>${qty} qty</div>
                    <div>Net Amount</div>
                    <div>${data.total}</div>
                </div>
                <hr style="height:2px; width:100%; border-width:0; color:black; background-color:black">
                <br/>
                <br/>
                <br/>


            </body>

            </html>`



};

export default SalesOrderPrintComponent;